/*
 * @Descripttion: 修改短信单价
 * @Author: yang chenglin
 * @LastEditors: yang chenglin
 */
import React, {useContext, useState, useEffect} from 'react';
import { NumberPicker, Button } from '@alifd/next';
import LzMsg from '@/components/common/LzMsg';
import { Servlets } from '@/service';
import {ActivityContext} from '../../index';
import styles from './index.module.scss';

const ChangePrice = () => {
  const {setChangePriceDialog} = useContext(ActivityContext);

  const [smsPrice, setSmsPrice] = useState(0);

  const confirmChange = () => {
    if (!smsPrice) {
      LzMsg.error('请输入短信单价');
    } else {
      Servlets('updateUnitPrice', {
        unitPrice: smsPrice,
      })
        .then((res) => {
          LzMsg.success('修改成功');
          getUnitPrice();
          setChangePriceDialog(false);
        })
        .catch(() => {});
    }
  };

  const getUnitPrice = () => {
    Servlets('getUnitPrice').then((res) => {
      if (res.success) {
        setSmsPrice(res.data);
      } else {
        LzMsg.error(res.resp_msg);
      }
    });
  };

  useEffect(() => {
    getUnitPrice();
  }, []);

  return (
    <div>
    <div className={styles['change-price-container']}>
      <div>
        <div style={{ padding: '30px 0' }}>
          <span>实际短信单价：</span>
          <NumberPicker
            hasTrigger={false}
            value={smsPrice}
            style={{ width: 200, marginRight: 5 }}
            onChange={(v) => {
              if (v || v === 0) {
                setSmsPrice(+v);
              } else {
                setSmsPrice(0);
              }
            }}
            precision={3}
          />
          <span>元/条</span>
        </div>
        <div style={{color: '#999999'}}>
          <div>注：1. 本次修改后，将会改变历史所有及未来短信任务的ROI数据结果；</div>
          <div>2. ROI = 成交金额 /（实际触达人数 * 短信单价），修改短信单价后，将会影响ROI的计算数值</div>
        </div>
      </div>
      <div>
        <img src="//img10.360buyimg.com/imgzone/jfs/t1/221705/8/50777/7820/675013b2Fa4986b98/71953821bd272612.png" alt="二维码" style={{width: 150, height: 150}}/>
        <div style={{color: 'red'}}>扫码了解更多短信优惠</div>
      </div>
    </div>
    <div className={styles.footer}>
      <Button
        type="primary"
        style={{ width: '88px' }}
        onClick={() => {
          confirmChange();
        }}
      >
        确认修改
      </Button>
      <Button
        style={{ marginLeft: '15px', width: '88px' }}
        onClick={() => {
          setChangePriceDialog(false);
          getUnitPrice();
        }}
      >
        取消
      </Button>
    </div>
    </div>
  )
};

export default ChangePrice;
